import axios from 'axios';
import { useEffect, useState } from 'react';
import CONFIG from '../../constanta/config';
import LogoApp from '../../components/logoapp';

const CardLead = (props) => {
  const [open, setOpen] = useState(props.open || false);

  return (
    <div className="w-full">
      <div
        className={`${
          open ? 'h-auto px-4 py-2' : 'h-0 px-4 py-0'
        } overflow-x-auto w-full flex flex-col  justify-between  bg-[#2b444f] font-semibold text-white`}>
        <div
          key={props.userkey}
          className={`${
            props.userkey % 2 === 0 ? 'bg-[#3d5b68]' : 'bg-[#4b626d]'
          } text-sm w-full flex justify-start px-4 py-2 font-semibold text-white`}>
          <div className="flex  flex-none w-12 mr-4 text-center">
            {props.userkey + 1}.
          </div>
          <div className="flex flex-grow w-40 mr-4 text-left">
            {props.item?.name}
          </div>

          <div className="flex flex-none w-28 mr-4 text-right justify-end">
              {props.item?.play_time} sec
            </div>

          <div className="flex flex-none w-28 text-right justify-end">
            {props.item?.score}
          </div>
        </div>
      </div>
    </div>
  );
};

const Leaderboard = (props) => {
  const [loading, setLoading] = useState(false);
  const [round2, setRound2] = useState([]);
  const [dataLead, setDataLead] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    axios
      .get(CONFIG.URL + '/leaderboard?limit=5000&rnd=' + Date.now())
      .then(function (response) {
        if (response.data.status === 'SUCCESS') {
          setDataLead(response.data.data);

          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
      });
  };

  return (
    <div className="w-full px-0 flex justify-center items-center">
      <div className="rounded-md md:h-max flex flex-col justify-between items-start px-2 w-full bg-[#ffffffd9] border-[4px] py-2 md:py-4">
        {loading ? (
          <div className="font-bold text-center w-full">Loading...</div>
        ) : (
          <>
            <div className="w-full flex justify-between space-x-5 uppercase font-bold text-2xl mb-3">
              <a
                href="/"
                className="font-bold flex-none cursor-pointer w-max h-max flex justify-center items-center text-sm  text-white px-4 py-2 border-b-4 border-red-700 bg-red-500 rounded-md ">
                BACK
              </a>
              <div className="w-full flex flex-col justify-center items-center">
                <LogoApp />
                <div className="uppercase font-bold text-xl">LEADERBOARD</div>
              </div>
              <div
                onClick={() => {
                  getData();
                }}
                className=" font-bold flex-none cursor-pointer w-max h-max px-4 py-2 flex justify-center items-center text-sm  text-white   border-b-4 border-green-700 bg-green-500 rounded-md ">
                REFRESH
              </div>
            </div>

            <div className="w-full">
              <div
                className={`h-auto px-4 py-2overflow-x-auto w-full flex flex-col  justify-between  bg-[#2b444f] font-semibold text-white`}>
                <div
                  key={props.userkey}
                  className={`mt-3 mb-2
                    bg-black
                  text-sm w-full flex justify-start px-4 py-2 font-semibold text-white`}>
                  <div className="flex  flex-none w-12 mr-4 text-center">
                    No.
                  </div>
                  <div className="flex flex-grow w-40 mr-4 text-left">Name</div>
                  <div className="flex flex-none w-28 mr-4 text-right justify-end">
                    TIME TAKEN
                  </div>

                  <div className="flex flex-none w-28 text-right justify-end">
                    Score
                  </div>
                </div>
              </div>
            </div>

            <div className={` w-full text-left`}>
              {dataLead?.map((item, key) => {
                return (
                  <CardLead
                    actRound={props?.actRound1}
                    item={item}
                    key={key}
                    userkey={key}
                    open={true}
                  />
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Leaderboard;
